/* ==========================================================================
   Bold Movement — bm-home.js
   Behavior for the NEW homepage sections (Priority 2).
   Ship as: theme/assets/bm-home.js
   - [data-bm-copycode] click-to-copy promo code
   - Final CTA colorway picker ([data-cta-swatch] / [data-cta-stage] / [data-cta-link])
   ========================================================================== */

(function () {
  'use strict';

  /* click-to-copy promo code */
  document.querySelectorAll('[data-bm-copycode]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-code') || 'BOLDME';
      var doCopy = function () {
        // If button has structured content (e.g. banner pill), toggle a class instead of replacing text
        if (btn.querySelector('[data-copy-label]')) {
          btn.classList.add('is-copied');
          setTimeout(function () { btn.classList.remove('is-copied'); }, 1800);
        } else {
          var prev = btn.textContent;
          btn.textContent = 'Copied';
          setTimeout(function () { btn.textContent = prev; }, 1800);
        }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(doCopy).catch(doCopy);
      } else {
        // Fallback for older browsers
        var ta = document.createElement('textarea');
        ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); doCopy(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  });

  /* final CTA — 3-color picker */
  var cta = document.querySelector('[data-bm-finalcta]');
  if (!cta) return;

  var stage = cta.querySelector('[data-cta-stage]');
  var img = cta.querySelector('[data-cta-img]');
  var link = cta.querySelector('[data-cta-link]');
  var nameEl = cta.querySelector('[data-cta-name]');

  // Preload each colorway image so tapping a swatch swaps instantly (no blank flash on mobile).
  cta.querySelectorAll('[data-cta-swatch]').forEach(function (b) {
    var src = b.getAttribute('data-img');
    if (src) { var im = new Image(); im.src = src; }
  });

  cta.querySelectorAll('[data-cta-swatch]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      cta.querySelectorAll('[data-cta-swatch]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      btn.setAttribute('aria-pressed', 'true');
      if (stage) stage.style.background = btn.getAttribute('data-stage') || '';
      if (img && btn.getAttribute('data-img')) {
        img.src = btn.getAttribute('data-img');
        img.alt = btn.getAttribute('data-alt') || '';
      }
      if (link && btn.getAttribute('data-url')) link.href = btn.getAttribute('data-url');
      if (nameEl) nameEl.textContent = btn.getAttribute('data-name') || '';
    });
  });
})();
